export class CategoryModel{
    constructor(public title:string, public description: string, public userID: string,public _id: string,){
        // return {title:this.title, description: this.desc}
    };

}